import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const PayIcon = (props) => {
  return (
    <SvgIcon
      {...props}
      width="28.745"
      height="19.163"
      viewBox="0 0 28.745 19.163"
    >
      <g transform="translate(0 -85.333)">
        <g transform="translate(0 85.333)">
          <path
            fill="#0a598d"
            d="M25.75,85.333H2.994A3,3,0,0,0,0,88.327V101.5A3,3,0,0,0,2.994,104.5H25.75a3,3,0,0,0,2.994-2.994V88.327A3,3,0,0,0,25.75,85.333Zm1.8,16.169a1.8,1.8,0,0,1-1.8,1.8H2.994a1.8,1.8,0,0,1-1.8-1.8V88.327a1.8,1.8,0,0,1,1.8-1.8H25.75a1.8,1.8,0,0,1,1.8,1.8V101.5Z"
            transform="translate(0 -85.333)"
          />
        </g>
        <g transform="translate(0 88.926)">
          <g transform="translate(0 0)">
            <path
              fill="#0a598d"
              d="M28.146,149.333H.6a.6.6,0,0,0-.6.6v3.593a.6.6,0,0,0,.6.6H28.146a.6.6,0,0,0,.6-.6v-3.593A.6.6,0,0,0,28.146,149.333Zm-.6,3.593H1.2v-2.4H27.547v2.4Z"
              transform="translate(0 -149.333)"
            />
          </g>
        </g>
        <g transform="translate(3.593 97.31)">
          <g transform="translate(0 0)">
            <path
              fill="#0a598d"
              d="M71.785,298.667H64.6a.6.6,0,1,0,0,1.2h7.186a.6.6,0,1,0,0-1.2Z"
              transform="translate(-64 -298.667)"
            />
          </g>
        </g>
        <g transform="translate(3.593 99.705)">
          <path
            fill="#0a598d"
            d="M71.785,341.333H64.6a.6.6,0,0,0,0,1.2h7.186a.6.6,0,0,0,0-1.2Z"
            transform="translate(-64 -341.333)"
          />
        </g>
        <g transform="translate(20.361 96.112)">
          <g transform="translate(0 0)">
            <path
              fill="#0a598d"
              d="M365.661,277.333h-1.2a1.8,1.8,0,0,0-1.8,1.8v1.2a1.8,1.8,0,0,0,1.8,1.8h1.2a1.8,1.8,0,0,0,1.8-1.8v-1.2A1.8,1.8,0,0,0,365.661,277.333Zm.6,2.994a.6.6,0,0,1-.6.6h-1.2a.6.6,0,0,1-.6-.6v-1.2a.6.6,0,0,1,.6-.6h1.2a.6.6,0,0,1,.6.6Z"
              transform="translate(-362.667 -277.333)"
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export default PayIcon;
